import { observer } from 'mobx-react-lite'

import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'

import { ChevronLeft } from '@mxenabled/mx-icons'

import { useAppConfig, WidgetContainer } from '../common'
import { WidgetProps } from '../core'

import { NotificationSettings } from './components/notifications/NotificationSettings'

export const NotificationSettingsWidget = observer((props: WidgetProps) => {
  const { clientConfig } = useAppConfig()

  const view = clientConfig?.master?.deep_link_params?.view
  const showBackButton = clientConfig?.master?.show_back_button

  if (view) {
    return (
      <Stack>
        {showBackButton && props.onBackClick && (
          <IconButton
            color="primary"
            onClick={props.onBackClick}
            sx={{ p: 10, alignSelf: 'flex-start' }}
          >
            <ChevronLeft size={24} />
          </IconButton>
        )}
        <NotificationSettings view={view} />
      </Stack>
    )
  }

  return (
    <WidgetContainer {...props} showAccountFilter={false}>
      <Stack my={24}>
        <NotificationSettings />
      </Stack>
    </WidgetContainer>
  )
})
